/**
 * @type RegExp
 */
export const snvcs = /^([0-9]+)$/i
/**
 * @type RegExp
 */
export const pvcs = /^([1-7]{1})(?:[ \-–—]?)(18|40|65)(?:[ \-–—]?)(\d{1,4})$/i
